import { render } from "./ConfirmarModal.vue?vue&type=template&id=45cf0782"
import script from "./ConfirmarModal.vue?vue&type=script&lang=js"
export * from "./ConfirmarModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__